import { Platform } from 'react-native';
import { Button } from '@/common/components/Button/Button';
import { Icon } from '@/common/components/Icons/Icon';
import { Stack } from '@/common/components/Stack/Stack';
import { ROUTES } from '@/common/constants/routes';
import { useBreakpoints } from '@/common/hooks/useBreakpoints';
import { useRouter } from 'expo-router';
import { TabTrigger } from 'expo-router/ui';

export function HomeActions() {
  const router = useRouter();
  const breakpoints = useBreakpoints(['lg']);

  if (breakpoints.lg) {
    return null;
  }

  const accountTrigger =
    Platform.OS === 'web' ? (
      <Button
        icon={<Icon icon="user" />}
        onPress={() => router.navigate(ROUTES.PROFILE)}
        variant="info"
        size="sm"
      />
    ) : (
      <TabTrigger name={ROUTES.PROFILE} asChild>
        <Button icon={<Icon icon="user" />} variant="info" size="sm" />
      </TabTrigger>
    );

  return (
    <Stack horizontal gap="sm">
      <Button
        icon={<Icon icon="credit-card" />}
        onPress={() =>
          router.navigate(ROUTES.CARD, {
            withAnchor: Platform.OS !== 'web',
          })
        }
        variant="info"
        size="sm"
      />
      {accountTrigger}
    </Stack>
  );
}
